import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ShieldCheck, LogIn } from 'lucide-react';

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate('/dashboard', { replace: true });
  }, [user, loading, navigate]);

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[80vh] grid place-items-center hero-gradient px-4">
      <div className="bg-white rounded-3xl shadow-2xl border border-teal-50 p-10 max-w-md w-full text-center">
        <span className="grid place-items-center w-16 h-16 rounded-2xl text-white mx-auto mb-6" style={{ background: 'linear-gradient(135deg,#0f766e,#0b3b3a)' }}>
          <ShieldCheck size={30} />
        </span>
        <h1 className="font-display text-3xl text-teal-900" style={{ fontWeight: 600 }}>Staff Sign In</h1>
        <p className="text-slate-600 mt-3 leading-relaxed">Access the clinic admin dashboard to view appointment &amp; second-opinion requests and subscribers.</p>
        <button onClick={signIn} className="btn-teal inline-flex items-center justify-center gap-3 w-full py-3.5 rounded-full font-semibold mt-8">
          <LogIn size={18} /> Continue with Google
        </button>
        <p className="text-xs text-slate-400 mt-5">Authorised staff only. Secured by Emergent authentication.</p>
      </div>
    </div>
  );
}
